import Modal from '../components/Shell/Modal';
import Bare from '../components/Shell/ShellBare';
import PDFViewer from '../components/nextgen/PDFViewer';

const PDFModal = ({ open, options, setClose, setOpen, children }) => {
	return (
		<Modal
			showCloseIcon={false}
			size="full"
			name={'uploadContractPdfModal'}
			onClose={() => setClose()}
		>
			<Bare
				onBack={() => setClose()}
				backText={options?.backText || 'Close'}
				actions={options?.actions || []}
				contentProps={{ maxWidth: 'w-full', fullWidth: true }}
				containerClassName="bg-gray-50"
			>
				<div className="grid grid-cols-12 gap-x-8 h-[calc(100vh-120px)]">
					<div className="col-span-4 overflow-y-auto">{children}</div>
					<div className="col-span-8">
						<PDFViewer url={options?.file} title="Contract PDF" height="100%" />
					</div>
				</div>
			</Bare>
		</Modal>
	);
};

export default PDFModal;
